import { DateTime } from "luxon"
import { appTimeContext } from "./context/app-time-context"
import { utcDateTimeSchema } from "./shared/date-utils/utc-date-time"
import { loadSp } from "./shared/search-params"
import type { TUtcDateTime } from "./shared/types"
import type { Route } from "./+types/root"

const appTimeMiddleware: Route.ClientMiddlewareFunction = async ({ context, url }, next) => {
  const func = "appTimeMiddleware"

  const sp = loadSp(url)
  const fat = sp.forcedAppTime === "" ? null : sp.forcedAppTime

  // When no forced app time is set, capture the current instant as a UTC ISO string.
  // This becomes a frozen snapshot that all loaders and components share for this
  // navigation/revalidation cycle, ensuring they agree on what "now" is.
  const appTime: TUtcDateTime = utcDateTimeSchema.parse(fat ?? DateTime.utc().toISO())

  console.log("🛡️🕑", { func, appTime, forced: fat !== null })

  context.set(appTimeContext, appTime)

  return next()
}

export const clientMiddleware: Route.ClientMiddlewareFunction[] = [appTimeMiddleware]
